import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=0bd5ff2c&"
import script from "./ErrorBanner.vue?vue&type=script&lang=ts&"
export * from "./ErrorBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports